module.exports = __webpack_public_path__ + "static/img/anxunMobel11.93e83bda.png";